import { apiClientSource } from "../common/axiosInstanceSource";
import { handleAxiosError } from "../common/handleAxiosError";
import { IResponseUploadDocToComment } from "./types";

export const uploadDocToComment = async (formData: FormData): Promise<IResponseUploadDocToComment> => {

  try {
    const data: IResponseUploadDocToComment = await apiClientSource.post("/task-service/api/comments/upload", formData,
      { headers: { "Content-Type": "multipart/form-data" } });
    return data;
  } catch (error) {
    handleAxiosError(error, "Error al subir el documento al comentario");
    throw error;
  }
};
